import { useState, useCallback } from 'react';

const TOKEN_KEY = 'remate_token';

/**
 * Manages JWT auth state backed by localStorage.
 */
export function useAuth() {
  const [token, setToken] = useState(() => localStorage.getItem(TOKEN_KEY));

  const login = useCallback((newToken) => {
    localStorage.setItem(TOKEN_KEY, newToken);
    setToken(newToken);
  }, []);

  const logout = useCallback(() => {
    localStorage.removeItem(TOKEN_KEY);
    setToken(null);
  }, []);

  return { token, login, logout, isAuthenticated: !!token };
}
